<template>
  <div>
    <el-dialog
    v-model="drawer"
    width="450"
    :modal='false'
    :show-close='false'
    custom-class="demo"
    draggable
    body-class='bodyclass'
    header-class="munemini"
  >
  <div class="chat-container">
        <div class="messages">
          <div class="content">
            <p class="content_1">
              <span class='mini_1'></span>
              <span style='margin-left:0.07rem;color:white;font-size:0.11rem'>在线客户</span>
            </p>
            <p @click='drawer = false' style='color:white; cursor:pointer;font-size:0.11rem'>
              —
            </p>
          </div>
          <div  class="message1">
            <span style='font-size:0.08rem; opacity:0.7;'>{{fot}}</span>
            <span >您好,感谢您的咨询，如有需要请<a style='color:red' @click.prevent="$router.push({ path: '/Subscribe' }),drawer=false">点击预约</a>，我们会尽快与您联系。</span>
          </div>
          <div v-for="message in messages" :key="message.id" class="message2">
            <span style='font-size:0.08rem; opacity:0.7;'>{{dateTime.time}}</span>
            <span>{{ message.text }}</span>
          </div>
        </div>
        <div class="input-area">
          <input
            v-model="newMessage"
            @keyup.enter="sendMessage"
            placeholder="&nbsp;&nbsp;很高兴为您服务，请描述您的问题"
            style='font-size:0.09rem;height:0.25rem'
          />
          <button style='font-size:0.11rem' @click="sendMessage">发送</button>
        </div>
      </div>
  </el-dialog>



    <!-- <el-drawer v-model="drawer"   footer-class="footerclass" header-class="muneminiheader" body-class="munemini">
      <div class="chat-container">
        <div class="messages">
          <div class="content">
            <p class="content_1">
              <span class='mini_1'></span>
              <span style='margin-left:0.07rem;color:white;font-size:0.12rem'>在线客户</span>
            </p>
            <p @click='drawer = false' style='color:white; cursor:pointer;'>
              —
            </p>
          </div>
          <div  class="message1">
            <span style='font-size:0.08rem; opacity:0.7;'>{{fot}}</span>
            <span>您好,感谢您的咨询，如有需要请<a style='color:red' @click.prevent="$router.push({ path: '/Subscribe' })">点击预约</a>，我们会尽快与您联系。</span>
          </div>
          <div v-for="message in messages" :key="message.id" class="message2">
            <span style='font-size:0.08rem; opacity:0.7;'>{{dateTime.time}}</span>
            <span>{{ message.text }}</span>
          </div>
        </div>
        <div class="input-area">
          <input
            v-model="newMessage"
            @keyup.enter="sendMessage"
            placeholder="很高兴为您服务，请描述您的问题"
            style='font-size:0.11rem;height:0.25rem'
          />
          <button style='font-size:0.11rem' @click="sendMessage">发送</button>
        </div>
      </div>
    </el-drawer> -->


  </div>
</template>
 
<script setup>
import { ref, onMounted, unref,reactive } from "vue";
import { ClickOutside as vClickOutside } from "element-plus";
import moment from "moment"
const messages = ref([]); // 存储消息的数组
const newMessage = ref(""); // 输入的新消息
const dateTime = reactive({
  time:''
}); // 输入的新消息
const fot = ref('')
// setInterval(() => {
 dateTime.time = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
 fot.value = dateTime.time
// }, 1000);

// 发送消息的方法
function sendMessage() {
  if (newMessage.value.trim() === "") return; // 检查消息是否为空
  const newMsg = { id: Date.now(), text: newMessage.value }; // 创建新消息对象
  messages.value.push(newMsg); // 将新消息添加到消息数组中
  newMessage.value = ""; // 清空输入框
}
const drawer = ref(false);
const flagchange = ()=>{
  drawer.value = true
}
defineExpose({
  flagchange
});
</script>
 
<style lang="scss" >
.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size:0.2rem;
}
.messages {
  
  
  flex: 1; /* 使消息区域可扩展 */
  overflow-y: auto; /* 启用滚动 */
  border:3px red #ededed;
  background:#fbfbfb;
  .content{
    background:#347afc;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    font-size:0.14rem;
    height:0.3rem;
    align-items:center;
    /* box-sizing: border-box; */
    padding:0 0.1rem;
    .content_1{
      display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    }
    .mini_1{
      display: inline-block;
      height:0.25rem;
      width:0.25rem;
      /* border:1px solid red; */
      border-radius:50% ;
      background:url('../../assets/ecological-Cooperation/kf.jpg') center no-repeat;
      background-size:cover;
    }
  }
}
.message1 {
  margin: 3px; /* 间距 */
  /* float:left */
  font-size:0.11rem;
  /* background:#5d7cb6; */
  display:flex;
  flex-direction:column;
  color:#383838;
  padding:0.07rem 0.09rem;
  border-radius:9% ;
  line-height:0.14rem;
}
.message2 {
  margin: 3px; /* 间距 */
  /* float:right */
  display:flex;
  flex-direction:column;
  justify-content:flex-end;
  align-items:flex-end;
  /* margin-top:0.01rem; */
  /* background:#5d7cb6; */
  /* display:inline-block; */
  color:#383838;
  padding:0.07rem 0.09rem;
  border-radius:9% ;
  font-size:0.11rem;
  line-height:0.14rem;
 
  /* width:3rem */
}
.input-area {
  display: flex; /* 使输入框和按钮水平排列 */

}
input {
  flex: 1; /* 使输入框扩展 */
}

.munemini{
  padding:0;
  margin:0;
  // width:300px;
}
.muneminibody{
  // height: 600px;
  // width: 400px;
}
.el-drawer{
  // height:600px
}
// .muneminiheader{
//   height:600px
// }
.bodyclass{
  height: 2.4rem;
  // height:600px
}
.demo{
  margin-left:900px;
}
.demo> .el-dialog__body {
  margin-left:900px;
}
</style>